import { tasksRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { AssociateAutomationModel } from '../types/associate-automation-model';

export const useAssociateAutomation = () =>
  useMutation<void, unknown, AssociateAutomationModel>((automation) =>
    tasksRepo.associateAutomation(automation),
  );
